import { Decimal } from "classes/DecimalClasses";

export const LINE_FIELDS_TO_TRANSFORM = {
  DECIMAL_FIELDS: ["weight", "height", "length", "width"],
  MONEY_FIELDS: [],
  DATE_FIELDS: [],
  DATETIME_FIELDS: [],
  NON_UTC_DATETIME_FIELDS: [],
};

export const EMPTY_LINE = {
  description: null,
  dimensionUnit: "in",
  freightClass: "50",
  height: Decimal.ZERO,
  length: Decimal.ZERO,
  lineId: null,
  lineNumber: null,
  weight: Decimal.ZERO,
  weightUnit: "lb",
  width: Decimal.ZERO,
};
